export function CurrentSystemBadge() {
  return (
    <span className="absolute -top-3 left-1/2 -translate-x-1/2 px-2 py-0.5 bg-purple-600 text-white text-[10px] font-bold rounded-full shadow-sm whitespace-nowrap z-10 pointer-events-none animate-in fade-in slide-in-from-bottom-2">
      当前系统
    </span>
  );
}
